import { render, staticRenderFns } from "./mobile-nav-user-header.vue?vue&type=template&id=509ef3ad&scoped=true&"
import script from "./mobile-nav-user-header.vue?vue&type=script&lang=ts&"
export * from "./mobile-nav-user-header.vue?vue&type=script&lang=ts&"
import style0 from "./mobile-nav-user-header.vue?vue&type=style&index=0&id=509ef3ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509ef3ad",
  null
  
)

export default component.exports